import axios from "@/services/axios.config";

/** Update a timesheet row (hours, project, notes — existing edit-timesheet API). */
export async function updateKonekoTimesheetEntry(timesheetId, payload) {
  const res = await axios.put(
    `api/users/timesheets/edit-timesheet/${timesheetId}`,
    payload,
    {timeout: 10000}
  );
  return res.data || {};
}

/** @deprecated Use updateKonekoTimesheetEntry */
export async function reassignTimesheetProject(timesheetId, payload) {
  return updateKonekoTimesheetEntry(timesheetId, payload);
}
